import React from 'react';
import { Flex, Typography } from 'antd';

const { Text, Link } = Typography;

export const MainBotInfo = ({ data }) => {
    const handleViewBot = (name: string) => {
        window.open(`https://t.me/${name}`);
    };

    return (
        <>
            <Flex vertical={false} gap={4}>
                <Text>{'Имя:'}</Text>
                <Text>{data.bot_full_name}</Text>
            </Flex>
            <Flex vertical={false} gap={4}>
                <Text>{'Юзернейм: '}</Text>
                <Link
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() => handleViewBot(data.bot_name)}
                >
                    @{data.bot_name}
                </Link>
            </Flex>
        </>
    );
};
